/* eslint-disable no-nested-ternary */
import React, { useCallback, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import Dropzone from 'react-dropzone';
import { Field } from 'react-final-form';
import _ from 'lodash';

import { AudioPlayer, Intl } from 'components';
import { required } from 'config/InputErrors';
import { useSelector } from 'react-redux';

const SingleFile = ( { field, submitErrors, onUpload } ) => {
  const userData = useSelector( ( state ) => state.user );
  const { locale } = useSelector( ( state ) => state.settings.locale );
  const [localError, setLocalErrors] = useState( null );

  const errMsg = useCallback(
    ( seconds ) => {
      if ( locale === 'en' ) {
        return `This audio should take less than ${seconds} seconds`;
      }
      return `Este audio no debe superar los ${seconds} segundos`;
    },
    [locale],
  );

  return (
    <Field name={field} validate={required}>
      {( { input } ) => (
        <>
          {_.isString( submitErrors ) && (
            <div className="error mt-1 text-md text-center">
              <Intl id={submitErrors} />
            </div>
          )}

          <Dropzone
            maxSize={1048576}
            accept=".mp3"
            onDrop={( files ) => {
              if ( files && files[0] ) {
                const reader = new FileReader();
                reader.readAsDataURL( files[0] );
                reader.onload = ( event ) => {
                  const audio = document.createElement( 'audio' );
                  audio.src = event.target.result;
                  audio.addEventListener(
                    'loadedmetadata',
                    () => {
                      const fileLimit = field === 'singleFile'
                        ? userData && userData.simpleMessageLimit
                        : field === 'introductionFile'
                          ? userData && userData.introLimit
                          : field === 'optionsFile'
                            ? userData && userData.optionsLimit
                            : field === 'farewellFile'
                              ? userData && userData.farewellLimit
                              : ( userData.simpleMessageLimit || 60 );
                      if (
                        fileLimit
                          ? audio.duration > fileLimit
                          : audio.duration > 60
                      ) {
                        input.onChange( null );
                        setLocalErrors(
                          errMsg( userData && fileLimit ? fileLimit : 60 ),
                        );
                      } else {
                        input.onChange( files[0] );
                        setLocalErrors( null );
                        onUpload( field, {
                          mediaFile: files[0],
                          originalName: files[0].name,
                          time:
                            parseInt( audio.duration, 10 ) === 0
                              ? 1
                              : parseInt( audio.duration, 10 ),
                        } );
                      }
                    },
                    false,
                  );
                };
              } else {
                input.onChange( null );
                setLocalErrors( 'invalidFormat' );
              }
            }}
          >
            {( { getRootProps, getInputProps } ) => (
              <Row className="mt-5 pt-4">
                <Col md={8} className="m-auto" onClick={getRootProps().onClick}>
                  <input {...getInputProps()} />
                  <Button color="app-default" size="app-sm" type="button" block>
                    <Intl id="selectFile" />
                  </Button>
                </Col>
              </Row>
            )}
          </Dropzone>
          <Row className="mt-5">
            <Col md={8} className="m-auto">
              <p className="text-center text-sm text-mp-orange-1 mb-0">
                {input.value ? (
                  input.value.originalName || input.value.name
                ) : (
                  <br />
                )}
              </p>
              <div className="mt-4">
                <AudioPlayer src={input.value ? input.value.uri : ''} />
              </div>
            </Col>
          </Row>

          {!!localError && (
            <div className="error mt-1 text-md text-center">
              {localError.indexOf( ' ' ) >= 0 ? (
                localError
              ) : (
                <Intl id={localError} />
              )}
            </div>
          )}
        </>
      )}
    </Field>
  );
};

export default SingleFile;
